var ThumbAnim = function () {

  function init() {
  //   $(window).on('scroll', $.throttle(250, reveal));
  //   // reveal();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const $el = $(entry.target);
        if($el.hasClass('revealed')) {
          return;
        }
        if (entry.isIntersecting) {
          $el.addClass('revealed');

          var $player_wrapper, $player, $iframe, $video;

          $player_wrapper = $el.find('.work-item-block__player');
          $iframe = $player_wrapper.find('.handstick');
          $video = $el.find('.video_file video');

          if($iframe.length) {
            setTimeout(function () {
              $player = new Vimeo.Player($iframe[0], {
                width: 640,
                responsive: true
              });
            }, 500);

            $el.find('.work-item-block__player-image').on('click', function (e) {
              var $image = $(this);
              $player.play();
              $player.on('play', function () {
                $image.css('opacity', 0);
                setTimeout(function () {
                  $player_wrapper.css('z-index', 2);
                }, 500);
              })
            });
          }
          if($video.length) {
            $video[0].play();
          }
        }
      });
    },
  );
  $('.reveal:not(.revealed)').each((i, el) => {
    observer.observe(el);
  });
  }



  return {
    init: init
  }

}();
